<script setup lang="ts">
    import { InputRow } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { Textarea } from '@/components/ui/textarea';

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid gap-3 sm:grid-cols-1">
        <InputRow
            :form="form"
            name="reporting_account"
            label="bi_and_companies.reporting_account"
        >
            <Input
                id="reporting_account"
                v-model="form.reporting_account"
                :placeholder="$t('bi_and_companies.reporting_account')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="reporting_account_nr"
            label="bi_and_companies.reporting_account_nr"
        >
            <Input
                id="number"
                v-model="form.reporting_account_nr"
                :placeholder="$t('bi_and_companies.reporting_account_nr')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="account_mapping"
            label="bi_and_companies.account_mapping"
        >
            <Textarea
                id="account_mapping"
                v-model="form.account_mapping"
                :placeholder="$t('bi_and_companies.account_mapping')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="measurement_calculation"
            label="bi_and_companies.measurement_calculation"
        >
            <Input
                id="measurement_calculation"
                v-model="form.measurement_calculation"
                :placeholder="$t('bi_and_companies.measurement_calculation')"
            />
        </InputRow>
    </div>
</template>
